<template>

<div class="flex min-h-screen w-screen items-center justify-center">
  <div class="w-full max-w-md">
    <div class="text-center text-3xl font-extrabold text-gray-900">Shopping Cart</div>
    <div>
      <h2 class="mt-6 text-center text-2xl text-gray-900">登入</h2>
    </div>
    <Form class="mt-8 space-y-6" @submit="signin">
      <div class="-space-y-px rounded-md shadow-sm">
        <div>
          <Field v-model="userData.email" type="email" name="email" autocomplete="email" required class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="帳號" rules="required"/>
        </div>
        <div>
          <Field v-model="userData.password" name="password" type="password" autocomplete="current-password" required class="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="密碼" rules="required" />
        </div>
      </div>

      <div>
        <button type="submit" class="relative flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-3 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-400">
          登入
        </button>
      </div>
    </Form>
  </div>
</div>

</template>

<script>
import { Form, Field, defineRule } from 'vee-validate';
import { required,  alpha, email } from '@vee-validate/rules';
//import axios from 'axios';
import { useUserLoginStore } from '../store/Storelogin';

defineRule('required', required);
defineRule('alpha', alpha);
defineRule('email', email);

export default {
    name: 'AppLogin',
    components: {
      Form,
      Field,
      //ErrorMessage,
    },
    data() {
      return {
        userData: {
            email: '',
            password: ''
          }
      };
    },
    login() {
        return {
            isShow: false,
        };
    },
    methods: {
      // VeeValidate 的提交函數會自動接收 values
      async signin (values) {
        console.log('進入 signin 函數', values); 
        const store = useUserLoginStore();
        //console.log('表單數值:', values);
      if(values.email === 'user' && values.password === 'user')
      {
        const result = await store.loginUser(values.email, values.password);
        console.log(result);
      } else if(values.email === 'admin' && values.password === 'admin')
      {
        const result = await store.loginUser(values.email, values.password);
        console.log(result);
      } else {
        console.log('Please enter right user and password');
      }


        /*
        try {
        const response =  await axios.post('/api/user/login', {                 
                user_mail: values.email,
                user_password: values.password 
            });
            console.log('伺服器回應:', response.data);
            alert('成功登入！');
        } catch (error) {
          console.error('請求失敗資訊:', error.response ? error.response.data : error.message);
          alert('登入失敗，請檢查後端連線');
        }
        */
        //alert('註冊成功！');
      }
    }
};
</script>

<style>

</style>